export default {
  API_URL: "https://api.xs2event.com/v1",
  STRAPI_API_URL: import.meta.env.VITE_STRAPI_API_URL || "https://cms.xs2event.com/api",
  CDN_URL: "https://cdn.xs2event.com",
  XS2TICKET: "https://www.xs2ticket.com/download",
  ENV: "production",
  SENTRY_ENABLE: true,
  SENTRY_DSN: "https://745c38c1904d43aca828bb1fdc36278b@sentry.xs2event.com/24",
  SENTRY_SAMPLE_RATE: 1.0,
  EVENT_MEDIA_BASE_URL: "https://cdn.xs2event.com/media-production",
  MEDIA_CONTENT_URL: "https://cdn.xs2event.com/mediacontent",
  FLAGS_BASE_URL: "https://cdn.xs2event.com/flags-test",
  EVENT_MEDIA_COVER_PHOTO: "cover-photo",
  FORMULA_ONE_MEDIA_COVER_PHOTO: "https://cdn.xs2event.com/media-production/formula-1/cover-photo",
  VERSION: "f040fd7b",
  CLICKY: 101405593,
  HOTJAR: 3357273,
  WEBAPP: "portalv2",
  ITINERARY_BASE_URL: "https://itineraries.xs2event.com",
};
